import React, { useState } from "react";
import Modal from "react-modal";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { loginCall, loginKeyCall } from "../../calls";

import "./login.css";
import "./auth-signal.css";

Modal.setAppElement("#root");

/* Modale Log in — design "Signal" (claude.ai/design) */
const Login = (props) => {
  const { t } = useTranslation();

  const {
    setIsLoggedIn,
    setShowModal,
    showModal,
    setBalance,
    setShowModal2,
  } = props;

  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [isHidden, setHidden] = useState(true);
  const [loginError, setLoginError] = useState([]);
  // "email" (par defaut) ou "key" : connexion par cle de compte seule.
  const [mode, setMode] = useState("email");
  const [keyInput, setKeyInput] = useState("");
  const [keyHidden, setKeyHidden] = useState(true);

  const handleDataChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loginCall(loginData)
      .then((response) => {
        const { data } = response;
        localStorage.setItem("token", data.token);
        localStorage.setItem("id", data.user_id);
        setIsLoggedIn(true);
        setBalance(data.balance);
        setShowModal(false);
        setLoginData({ email: "", password: "" });
        setLoginError([]);
        setHidden(true);
      })
      .catch((err) => {
        const res = err?.response;
        const serverMsg = res?.data?.Message;
        if (serverMsg) {
          // Ancien message serveur (users/views.py, branche aujourd'hui commentee)
          setLoginError([/verify/i.test(serverMsg) ? t("signal.auth-verify-email") : serverMsg]);
        } else if (!res || res.status >= 500) {
          // Coupure reseau ou erreur serveur : ce n'est pas un mauvais mot de passe
          setLoginError([t("signal.t-try-again")]);
        } else {
          setLoginError([t("signal.auth-invalid")]);
        }
      });
  };

  // Connexion par cle : le serveur ignore la casse et les tirets.
  const handleKeySubmit = (e) => {
    e.preventDefault();
    loginKeyCall(keyInput.trim())
      .then((response) => {
        const { data } = response;
        localStorage.setItem("token", data.token);
        localStorage.setItem("id", data.user_id);
        setIsLoggedIn(true);
        setBalance(data.balance);
        setShowModal(false);
        setKeyInput("");
        setKeyHidden(true);
        setLoginError([]);
      })
      .catch((err) => {
        const res = err && err.response;
        if (res && res.status === 400) {
          setLoginError([t("signal.key-invalid")]);
        } else if (res && res.status === 429) {
          setLoginError([t("signal.key-too-many-attempts")]);
        } else if (!res || res.status >= 500) {
          setLoginError([t("signal.t-try-again")]);
        } else {
          setLoginError([t("signal.key-invalid")]);
        }
      });
  };

  const switchMode = (next) => {
    if (next === mode) return;
    setMode(next);
    setLoginError([]);
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={() => setShowModal(false)}
      className="auth-modal"
      contentLabel={t("overview.log-in")}
    >
      <div className="auth-card">
        <div className="auth-card__head">
          <h1 className="auth-card__title">{`${t("overview.log-in")}`}</h1>
          <button
            type="button"
            className="auth-card__close"
            onClick={() => setShowModal(false)}
            aria-label={t("signal.close")}
          >
            ✕
          </button>
        </div>

        {/* Deux modes : e-mail + mot de passe, ou cle de compte seule */}
        <div className="auth-tabs">
          <button
            type="button"
            className={`auth-tab ${mode === "email" ? "auth-tab--on" : ""}`}
            onClick={() => switchMode("email")}
          >
            {t("signal.auth-mode-email")}
          </button>
          <button
            type="button"
            className={`auth-tab ${mode === "key" ? "auth-tab--on" : ""}`}
            onClick={() => switchMode("key")}
          >
            {t("signal.auth-mode-key-login")}
          </button>
        </div>

        {loginError.map((item, index) => (
          <p key={index} className="auth-card__error">{item}</p>
        ))}

        {mode === "email" ? (
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 14 }}
        >
          <div className="auth-field">
            <span className="auth-field__label">{t("signal.auth-email")}</span>
            <div className="auth-field__box">
              <input
                required
                value={loginData.email}
                onChange={handleDataChange}
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
                autoComplete="email"
              />
            </div>
          </div>

          <div className="auth-field">
            <span className="auth-field__label">{t("signal.auth-password")}</span>
            <div className="auth-field__box">
              <input
                required
                value={loginData.password}
                onChange={handleDataChange}
                type={isHidden ? "password" : "text"}
                id="password"
                name="password"
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="auth-field__show"
                onClick={() => setHidden(!isHidden)}
              >
                {isHidden ? t("signal.auth-show") : t("signal.auth-hide")}
              </button>
            </div>
          </div>

          <button type="submit" className="auth-card__submit">
            {`${t("overview.log-in")}`}
          </button>
        </form>
        ) : (
        <form
          onSubmit={handleKeySubmit}
          style={{ display: "flex", flexDirection: "column", gap: 14 }}
        >
          <div className="auth-field">
            <span className="auth-field__label">{t("signal.key-label")}</span>
            <div className="auth-field__box">
              <input
                required
                value={keyInput}
                onChange={(e) => setKeyInput(e.target.value)}
                type={keyHidden ? "password" : "text"}
                id="account_key"
                name="account_key"
                placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
                autoComplete="off"
                spellCheck={false}
                autoCapitalize="characters"
                style={{ fontFamily: "var(--font-mono)" }}
              />
              <button
                type="button"
                className="auth-field__show"
                onClick={() => setKeyHidden(!keyHidden)}
              >
                {keyHidden ? t("signal.auth-show") : t("signal.auth-hide")}
              </button>
            </div>
          </div>

          <button type="submit" className="auth-card__submit">
            {`${t("overview.log-in")}`}
          </button>
        </form>
        )}

        {/* Mot de passe oublie : sans objet en connexion par cle */}
        {mode === "email" && (
          <NavLink
            onClick={() => setShowModal(false)}
            to={`/forget-password`}
            className="auth-card__forget"
          >
            {`${t("overview.forget-pass")}`}
          </NavLink>
        )}

        <div className="auth-card__divider"><span>{t("signal.auth-or")}</span></div>

        <a
          className="auth-card__alt"
          href="https://telegram.me/twofasms"
          target="_blank"
          rel="noreferrer"
        >
          <span className="auth-card__alt-ic">TG</span>
          {t("signal.auth-tg")}
        </a>

        <p className="auth-card__switch">
          {`${t("overview.account-qst")}`}{" "}
          <button
            type="button"
            className="linkbtn"
            onClick={() => {
              setShowModal(false);
              setShowModal2(true);
            }}
          >
            {`${t("overview.sign-up")}`}
          </button>
        </p>
      </div>
    </Modal>
  );
};

export default Login;
